import {DRIVING_LICENSE_DURATIONS_NEEDING_LICENSE_DATE_LIST} from "@constants/dropdown-choices";
import {isNotStringOrEmptyString} from "@utils/string";
import {isDateGreaterThenToday} from "@utils/date-time";
import {isValidDateTimeString} from "@utils/validators";


export const ValidateStep2Data = (data) => {

    const msgList = [/*{
        name : 'test',
        message : 'Hold!',
    }*/];
    

    if (!data.drivingLicenseType || !data.drivingLicenseType.trim()) {
        msgList.push({
            name: 'drivingLicenseType',
            message: 'Driving license type is required'
        });
    }

    if (!data.provideDrivingLicenseNumber || !data.provideDrivingLicenseNumber.trim()) {
        msgList.push({
            name: 'provideDrivingLicenseNumber',
            message: 'Please select if you want to provide driving license number'
        });
    }

    if (!data.britishDrivingLicenseNumber || !data.britishDrivingLicenseNumber.trim()) {
        msgList.push({
            name: 'britishDrivingLicenseNumber',
            message: 'British driving license number is required'
        });
    }


    if (!data.drivingLicenseDuration || !data.drivingLicenseDuration.trim()) {
        msgList.push({
            name: 'drivingLicenseDuration',
            message: 'Driving license duration is required'
        });
    }

    if (doesRequireLicenseDate(data)) {

        if (!data.drivingLicenseDate || !data.drivingLicenseDate.trim()) {
            msgList.push({
                name: 'drivingLicenseDate',
                message: 'Driving license date is required'
            });
        }

    }

    if (!data.dvlaMedicalConditions || !data.dvlaMedicalConditions.trim()) {
        msgList.push({
            name: 'dvlaMedicalConditions',
            message: 'DVLA medical conditions option is required'
        });
    }

    if (shouldDisplayAdditionalDrivingQualificationDate(data)) {

        if (!isValidDateTimeString(data.additionalDrivingQualificationDate)) {
            msgList.push({
                name: 'additionalDrivingQualificationDate',
                message: 'Date of additional driving qualification obtaining is required'
            });
        } else if(isDateGreaterThenToday(data.additionalDrivingQualificationDate)) {
            
            msgList.push({
                name: 'additionalDrivingQualificationDate',
                message: 'The date of additional driving qualification obtaining cannot be in the future!'
            });
            
        }

    }

    if (!data.isBornInUk || !data.isBornInUk.trim()) {
        msgList.push({
            name: 'isBornInUk',
            message: 'Please select if you are born in UK'
        });
    }
    
    if('No' === data.isBornInUk) {
       
       if(isNotStringOrEmptyString(data.lastDateBecameUKResident)) {
          msgList.push({
               name: 'lastDateBecameUKResident',
               message: 'Please specify the date you became a UK resident'
           });
       } else if(isDateGreaterThenToday(data.lastDateBecameUKResident)) {
          
          msgList.push({
               name: 'lastDateBecameUKResident',
               message: 'The date you became a UK resident cannot be in the future!'
           });
          
       }
       
    }

    if (!data.hasNonMotoringCriminalConvictions || !data.hasNonMotoringCriminalConvictions.trim()) {
        msgList.push({
            name: 'hasNonMotoringCriminalConvictions',
            message: 'Please specify if there is any motoring convictions, driving licence endorsements or fixed penalty points within the last 5 years'
        });
    }

    return msgList;

}

const shouldDisplayAdditionalDrivingQualificationDate = (data) => {

    if (!data.additionalDrivingQualifications
        || !data.additionalDrivingQualifications.trim()) {
        return false;
    }

    return data.additionalDrivingQualifications !== 'No';

    
}

const doesRequireLicenseDate = (data) => {

    return DRIVING_LICENSE_DURATIONS_NEEDING_LICENSE_DATE_LIST.includes(data.drivingLicenseDuration);

}